import MissionAdmin from "../section/missionadminpage/MissionAdmin";

export default function MissionAdminPage() {
  return (
    <div className="h-full">
        <MissionAdmin/>
    </div>
  )
}
